/**
 * Theme Layout Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts and styles for all pages.
 *
 * @namespace theme
 * @file theme.js
 *
 */

const EVENT_VARIANT_CHANGE = new CustomEvent("variantChange", { "detail": "The variant has been updated."});
const ON_CHANGE_DEBOUNCE_TIMER = 300;
const PUB_SUB_EVENTS = { cartUpdate: "cart-update", quantityUpdate: "quantity-update", variantChange: "variant-change" };

window.theme = window.theme || {}; 
window.theme.sections = window.theme.sections || {}; 

theme.vendor = theme.vendor || {};

theme.constants = {
	ON_CHANGE_DEBOUNCE_TIMER: 300,
	PUB_SUB_EVENTS: {
		cartUpdate: 'cart-update',
		quantityUpdate: 'quantity-update',
		variantChange: 'variant-change'
	},
	BREAKPOINTS: {
		xsmall: 600,
		small: 750,
		medium: 990,
		large: 1250,
		xlarge: 1500,
	}
}

// From Component-PubSub

let subscribers = {};

function subscribe(s, r) {
  return void 0 === subscribers[s] && (subscribers[s] = []), subscribers[s] = [...subscribers[s], r],
    function () {
      subscribers[s] = subscribers[s].filter((s => s !== r))
    }
}

function publish(s, r) {
  subscribers[s] && subscribers[s].forEach((s => {
    s(r)
  }))
}

theme.methods = { 
	getStyleValue: function (variable) {
		const root = document.querySelector(':root');
		let computedStyleRoot = getComputedStyle(root);
		let value = computedStyleRoot.getPropertyValue(variable);
		//console.log(`getStyleValue: ${value}`); 
		return value;
	},
	setStyleValue: function (variable, value) {
		const root = document.querySelector(':root');
		root.style.setProperty(variable, value);
		//console.log(`setStyleValue: ${variable}, ${value}`);
	},
	getOuterHeight: function (el) {
		let $el = typeof el === 'string' ? document.querySelector(el) : el;
		let height = $el.clientHeight;
		height += parseInt(window.getComputedStyle($el).getPropertyValue('margin-top'));
		height += parseInt(window.getComputedStyle($el).getPropertyValue('margin-bottom'));
		return height;
	},
  waitForVariable: function (variable) {
    return new Promise((resolve) => {
      if (variable) {
        return resolve(variable);
      }
    });
  },
	viewPortHeight: function () {
		var de = document.documentElement;
		if(!window.innerWidth)
		{ return window.innerHeight; } 
		else if( de && !isNaN(de.clientHeight) )
		{ return de.clientHeight; }
		return 0;
	},
	scrollY: function () {
		if( window.pageYOffset ) { return window.pageYOffset; }
		return Math.max(document.documentElement.scrollTop, document.body.scrollTop);
	},
	isInViewport: function (el) {
		const rect = el.getBoundingClientRect();
		return (
				rect.top >= 0 &&
				rect.left >= 0 &&
				rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
				rect.right <= (window.innerWidth || document.documentElement.clientWidth)
		);
	},
	removeEmpty: function (obj) {
		return Object.fromEntries(Object.entries(obj).filter(([_, v]) => v != null));
	},
	nodeToString: function (node) {
		return node.outerHTML || new XMLSerializer().serializeToString(node);
	},
	createMediaSlider: function (cell = 'div.product-image', wrapper = '.product-images', settings) {
    theme.waitForElement('body.swiper--enabled').then(() => { 
      theme.methods.mediaSlider = new theme.vendor.Swiper(wrapper, settings);
    });
	},
  addItem: async function (variant_id, quantity, callback) {
    var quantity = quantity || 1;
    let data = { items: [{ id: variant_id, quantity: quantity }]}
    await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    });
  }
}







// From Component-Global

function getFocusableElements(t) {
  return Array.from(t.querySelectorAll("summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"))
}
document.querySelectorAll('[id^="Details-"] summary').forEach((t => {
  t.setAttribute("role", "button"), t.setAttribute("aria-expanded", t.parentNode.hasAttribute("open")), t.nextElementSibling.getAttribute("id") && t.setAttribute("aria-controls", t.nextElementSibling.id), t.addEventListener("click", (t => {
    t.currentTarget.setAttribute("aria-expanded", !t.currentTarget.closest("details").hasAttribute("open"))
  })), t.closest("header-drawer") || t.parentElement.addEventListener("keyup", onKeyUpEscape)
}));
const trapFocusHandlers = {};

function trapFocus(t, e = t) {
  var i = getFocusableElements(t),
    s = i[0],
    n = i[i.length - 1];
  removeTrapFocus(), trapFocusHandlers.focusin = e => {
    e.target !== t && e.target !== n && e.target !== s || document.addEventListener("keydown", trapFocusHandlers.keydown)
  }, trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown)
  }, trapFocusHandlers.keydown = function (e) {
    "TAB" === e.code.toUpperCase() && (e.target !== n || e.shiftKey || (e.preventDefault(), s.focus()), e.target !== t && e.target !== s || !e.shiftKey || (e.preventDefault(), n.focus()))
  }, document.addEventListener("focusout", trapFocusHandlers.focusout), document.addEventListener("focusin", trapFocusHandlers.focusin), e.focus(), "INPUT" === e.tagName && ["search", "text", "email", "url"].includes(e.type) && e.value && e.setSelectionRange(0, e.value.length)
}
try {
  document.querySelector(":focus-visible")
} catch (t) {
  focusVisiblePolyfill()
}

function focusVisiblePolyfill() {
  const t = ["ARROWUP", "ARROWDOWN", "ARROWLEFT", "ARROWRIGHT", "TAB", "ENTER", "SPACE", "ESCAPE", "HOME", "END", "PAGEUP", "PAGEDOWN"];
  let e = null,
    i = null;
  window.addEventListener("keydown", (e => {
    t.includes(e.code.toUpperCase()) && (i = !1)
  })), window.addEventListener("mousedown", (t => {
    i = !0
  })), window.addEventListener("focus", (() => {
    e && e.classList.remove("focused"), i || (e = document.activeElement, e.classList.add("focused"))
  }), !0)
}

function pauseAllMedia() {
  document.querySelectorAll(".js-youtube").forEach((t => {
    t.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', "*")
  })), document.querySelectorAll(".js-vimeo").forEach((t => {
    t.contentWindow.postMessage('{"method":"pause"}', "*")
  })), document.querySelectorAll("video").forEach((t => t.pause())), document.querySelectorAll("product-model").forEach((t => {
    t.modelViewerUI && t.modelViewerUI.pause()
  }))
}

function removeTrapFocus(t = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin), document.removeEventListener("focusout", trapFocusHandlers.focusout), document.removeEventListener("keydown", trapFocusHandlers.keydown), t && t.focus()
}

function onKeyUpEscape(t) {
  if ("ESCAPE" !== t.code.toUpperCase()) return;
  const e = t.target.closest("details[open]");
  if (!e) return;
  const i = e.querySelector("summary");
  e.removeAttribute("open"), i.setAttribute("aria-expanded", !1), i.focus()
}
class QuantityInput extends HTMLElement {
  constructor() {
    super(), this.input = this.querySelector("input"), this.changeEvent = new Event("change", {
      bubbles: !0
    }), this.input.addEventListener("change", this.onInputChange.bind(this)), this.querySelectorAll("button").forEach((t => t.addEventListener("click", this.onButtonClick.bind(this))))
  }
  quantityUpdateUnsubscriber = void 0;
  connectedCallback() {
    this.validateQtyRules(), this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this))
  }
  disconnectedCallback() {
    this.quantityUpdateUnsubscriber && this.quantityUpdateUnsubscriber()
  }
  onInputChange(t) {
    this.validateQtyRules()
  }
  onButtonClick(t) {
    t.preventDefault();
    const e = this.input.value;
    "plus" === t.target.name ? this.input.stepUp() : this.input.stepDown(), e !== this.input.value && this.input.dispatchEvent(this.changeEvent)
  }
  validateQtyRules() {
    const t = parseInt(this.input.value);
    if (this.input.min) {
      const e = parseInt(this.input.min);
      this.querySelector(".quantity__button[name='minus']").classList.toggle("disabled", t <= e)
    }
    if (this.input.max) {
      const e = parseInt(this.input.max);
      this.querySelector(".quantity__button[name='plus']").classList.toggle("disabled", t >= e)
    }
  }
}

function debounce(t, e) {
  let i;
  return (...s) => {
    clearTimeout(i), i = setTimeout((() => t.apply(this, s)), e)
  }
}

function fetchConfig(t = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${t}`
    }
  }
}
customElements.define("quantity-input", QuantityInput), void 0 === window.Shopify && (window.Shopify = {}), Shopify.bind = function (t, e) {
  return function () {
    return t.apply(e, arguments)
  }
}, Shopify.setSelectorByValue = function (t, e) {
  for (var i = 0, s = t.options.length; i < s; i++) {
    var n = t.options[i];
    if (e == n.value || e == n.innerHTML) return t.selectedIndex = i, i
  }
}, Shopify.addListener = function (t, e, i) {
  t.addEventListener ? t.addEventListener(e, i, !1) : t.attachEvent("on" + e, i)
}, Shopify.postLink = function (t, e) {
  var i = (e = e || {}).method || "post",
    s = e.parameters || {},
    n = document.createElement("form");
  for (var r in n.setAttribute("method", i), n.setAttribute("action", t), s) {
    var o = document.createElement("input");
    o.setAttribute("type", "hidden"), o.setAttribute("name", r), o.setAttribute("value", s[r]), n.appendChild(o)
  }
  document.body.appendChild(n), n.submit(), document.body.removeChild(n)
}, Shopify.CountryProvinceSelector = function (t, e, i) {
  this.countryEl = document.getElementById(t), this.provinceEl = document.getElementById(e), this.provinceContainer = document.getElementById(i.hideElement || e), Shopify.addListener(this.countryEl, "change", Shopify.bind(this.countryHandler, this)), this.initCountry(), this.initProvince()
}, Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var t = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, t), this.countryHandler()
  },
  initProvince: function () {
    var t = this.provinceEl.getAttribute("data-default");
    t && this.provinceEl.options.length > 0 && Shopify.setSelectorByValue(this.provinceEl, t)
  },
  countryHandler: function (t) {
    var e = (n = this.countryEl.options[this.countryEl.selectedIndex]).getAttribute("data-provinces"),
      i = JSON.parse(e);
    if (this.clearOptions(this.provinceEl), i && 0 == i.length) this.provinceContainer.style.display = "none";
    else {
      for (var s = 0; s < i.length; s++) {
        var n;
        (n = document.createElement("option")).value = i[s][0], n.innerHTML = i[s][1], this.provinceEl.appendChild(n)
      }
      this.provinceContainer.style.display = ""
    }
  },
  clearOptions: function (t) {
    for (; t.firstChild;) t.removeChild(t.firstChild)
  },
  setOptions: function (t, e) {
    var i = 0;
    for (e.length; i < e.length; i++) {
      var s = document.createElement("option");
      s.value = e[i], s.innerHTML = e[i], t.appendChild(s)
    }
  }
};
class MenuDrawer extends HTMLElement {
  constructor() {
    super(), this.mainDetailsToggle = this.querySelector("details"), this.addEventListener("keyup", this.onKeyUp.bind(this)), this.addEventListener("focusout", this.onFocusOut.bind(this)), this.bindEvents()
  }
  bindEvents() {
    this.querySelectorAll("summary").forEach((t => t.addEventListener("click", this.onSummaryClick.bind(this)))), this.querySelectorAll("button").forEach((t => t.addEventListener("click", this.onCloseButtonClick.bind(this))))
  }
  onKeyUp(t) {
    if ("ESCAPE" !== t.code.toUpperCase()) return;
    const e = t.target.closest("details[open]");
    e && (e === this.mainDetailsToggle ? this.closeMenuDrawer(t, this.mainDetailsToggle.querySelector("summary")) : this.closeSubmenu(e))
  }
  onSummaryClick(t) {
    console.log('Opened');

    const e = t.currentTarget,
      i = e.parentNode,
      s = i.closest(".has-submenu"),
      n = i.hasAttribute("open"),
      r = window.matchMedia("(prefers-reduced-motion: reduce)");

    function o() {
      trapFocus(e.nextElementSibling, i.querySelector("button")), e.nextElementSibling.removeEventListener("transitionend", o)
    }
    i === this.mainDetailsToggle ? (n && t.preventDefault(), n ? this.closeMenuDrawer(t, e) : this.openMenuDrawer(e), window.matchMedia("(max-width: 990px)") && document.documentElement.style.setProperty("--viewport-height", `${window.innerHeight}px`)) : setTimeout((() => {
      i.classList.add("menu-opening"), e.setAttribute("aria-expanded", !0), s && s.classList.add("submenu-open"), !r || r.matches ? o() : e.nextElementSibling.addEventListener("transitionend", o)
    }), 100)
  }
  openMenuDrawer(t) {
    setTimeout((() => {
      this.mainDetailsToggle.classList.add("menu-opening")
    })), t.setAttribute("aria-expanded", !0), trapFocus(this.mainDetailsToggle, t), document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`)
  }
  closeMenuDrawer(t, e = !1) {
    void 0 !== t && (this.mainDetailsToggle.classList.remove("menu-opening"), this.mainDetailsToggle.querySelectorAll("details").forEach((t => {
      t.removeAttribute("open"), t.classList.remove("menu-opening")
    })), this.mainDetailsToggle.querySelectorAll(".submenu-open").forEach((t => {
      t.classList.remove("submenu-open")
    })), document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`), removeTrapFocus(e), this.closeAnimation(this.mainDetailsToggle))
  }
  onFocusOut(t) {
    setTimeout((() => {
      this.mainDetailsToggle.hasAttribute("open") && !this.mainDetailsToggle.contains(document.activeElement) && this.closeMenuDrawer()
    }))
  }
  onCloseButtonClick(t) {
    const e = t.currentTarget.closest("details");
    this.closeSubmenu(e)
  }
  closeSubmenu(t) {
    const e = t.closest(".submenu-open");
    e && e.classList.remove("submenu-open"), t.classList.remove("menu-opening"), t.querySelector("summary").setAttribute("aria-expanded", !1), removeTrapFocus(t.querySelector("summary")), this.closeAnimation(t)
  }
  closeAnimation(t) {
    let e;
    const i = s => {
      void 0 === e && (e = s), s - e < 400 ? window.requestAnimationFrame(i) : (t.removeAttribute("open"), t.closest("details[open]") && trapFocus(t.closest("details[open]"), t.querySelector("summary")))
    };
    window.requestAnimationFrame(i)
  }
}
customElements.define("menu-drawer", MenuDrawer);
class HeaderDrawer extends MenuDrawer {
  constructor() {
    super()
  }
  openMenuDrawer(t) {
    this.header = this.header || document.querySelector(".section-header"), this.borderOffset = this.borderOffset || this.closest(".header-wrapper").classList.contains("header-wrapper--border-bottom") ? 1 : 0, document.documentElement.style.setProperty("--header-bottom-position", `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`), this.header.classList.add("menu-open"), setTimeout((() => {
      this.mainDetailsToggle.classList.add("menu-opening")
    })), t.setAttribute("aria-expanded", !0), trapFocus(this.mainDetailsToggle, t), document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`)
  }
  closeMenuDrawer(t, e) {
    super.closeMenuDrawer(t, e), this.header.classList.remove("menu-open")
  }
}
customElements.define("header-drawer", HeaderDrawer);
class ModalDialog extends HTMLElement {
  constructor() {
    super(), this.querySelector('[id^="ModalClose-"]').addEventListener("click", this.hide.bind(this, !1)), this.addEventListener("keyup", (t => {
      "ESCAPE" === t.code.toUpperCase() && this.hide()
    })), this.classList.contains("media-modal") ? this.addEventListener("pointerup", (t => {
      "mouse" !== t.pointerType || t.target.closest("deferred-media, product-model") || this.hide()
    })) : this.addEventListener("click", (t => {
      t.target === this && this.hide()
    }))
  }
  connectedCallback() {
    this.moved || (this.moved = !0, document.body.appendChild(this))
  }
  show(t) {
    this.openedBy = t;
    const e = this.querySelector(".template-popup");
    document.body.classList.add("overflow-hidden"), this.setAttribute("open", ""), e && e.loadContent(), trapFocus(this, this.querySelector('[role="dialog"]')), window.pauseAllMedia()
  }
  hide() {
    document.body.classList.remove("overflow-hidden"), document.body.dispatchEvent(new CustomEvent("modalClosed")), this.removeAttribute("open"), removeTrapFocus(this.openedBy), window.pauseAllMedia()
  }
}
customElements.define("modal-dialog", ModalDialog);
class ModalOpener extends HTMLElement {
  constructor() {
    super();
    const t = this.querySelector("button");
    t && t.addEventListener("click", (() => {
      const e = document.querySelector(this.getAttribute("data-modal"));
      e && e.show(t)
    }))
  }
}
customElements.define("modal-opener", ModalOpener);
class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const t = this.querySelector('[id^="Deferred-Poster-"]');
    t && t.addEventListener("click", this.loadContent.bind(this))
  }
  loadContent(t = !0) {
    if (window.pauseAllMedia(), !this.getAttribute("loaded")) {
      const e = document.createElement("div");
      e.appendChild(this.querySelector("template").content.firstElementChild.cloneNode(!0)), this.setAttribute("loaded", !0);
      const i = this.appendChild(e.querySelector("video, model-viewer, iframe"));
      t && i.focus(), "VIDEO" == i.nodeName && i.getAttribute("autoplay") && i.play()
    }
  }
}
customElements.define("deferred-media", DeferredMedia);
class SliderComponent extends HTMLElement {
  constructor() {
    super(), this.slider = this.querySelector('[id^="Slider-"]'), this.sliderItems = this.querySelectorAll('[id^="Slide-"]'), this.enableSliderLooping = !1, this.currentPageElement = this.querySelector(".slider-counter--current"), this.pageTotalElement = this.querySelector(".slider-counter--total"), this.prevButton = this.querySelector('button[name="previous"]'), this.nextButton = this.querySelector('button[name="next"]'), this.slider && this.nextButton && (this.initPages(), new ResizeObserver((t => this.initPages())).observe(this.slider), this.slider.addEventListener("scroll", this.update.bind(this)), this.prevButton.addEventListener("click", this.onButtonClick.bind(this)), this.nextButton.addEventListener("click", this.onButtonClick.bind(this)))
  }
  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter((t => t.clientWidth > 0)), this.sliderItemsToShow.length < 2 || (this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft, this.slidesPerPage = Math.floor((this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset), this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1, this.update())
  }
  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]'), this.initPages()
  }
  update() {
    if (!this.slider || !this.nextButton) return;
    const t = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1, this.currentPageElement && this.pageTotalElement && (this.currentPageElement.textContent = this.currentPage, this.pageTotalElement.textContent = this.totalPages), this.currentPage != t && this.dispatchEvent(new CustomEvent("slideChanged", {
      detail: {
        currentPage: this.currentPage,
        currentElement: this.sliderItemsToShow[this.currentPage - 1]
      }
    })), this.enableSliderLooping || (this.isSlideVisible(this.sliderItemsToShow[0]) && 0 === this.slider.scrollLeft ? this.prevButton.setAttribute("disabled", "disabled") : this.prevButton.removeAttribute("disabled"), this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1]) ? this.nextButton.setAttribute("disabled", "disabled") : this.nextButton.removeAttribute("disabled"))
  }
  isSlideVisible(t, e = 0) {
    const i = this.slider.clientWidth + this.slider.scrollLeft - e;
    return t.offsetLeft + t.clientWidth <= i && t.offsetLeft >= this.slider.scrollLeft
  }
  onButtonClick(t) {
    t.preventDefault();
    const e = t.currentTarget.dataset.step || 1;
    this.slideScrollPosition = "next" === t.currentTarget.name ? this.slider.scrollLeft + e * this.sliderItemOffset : this.slider.scrollLeft - e * this.sliderItemOffset, this.slider.scrollTo({
      left: this.slideScrollPosition
    })
  }
}
customElements.define("slider-component", SliderComponent);
class SlideshowComponent extends SliderComponent {
  constructor() {
    super(), this.sliderControlWrapper = this.querySelector(".slider-buttons"), this.enableSliderLooping = !0, this.sliderControlWrapper && (this.sliderFirstItemNode = this.slider.querySelector(".slideshow__slide"), this.sliderItemsToShow.length > 0 && (this.currentPage = 1), this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll(".slider-counter__link")), this.sliderControlLinksArray.forEach((t => t.addEventListener("click", this.linkToSlide.bind(this)))), this.slider.addEventListener("scroll", this.setSlideVisibility.bind(this)), this.setSlideVisibility(), "true" === this.slider.getAttribute("data-autoplay") && this.setAutoPlay())
  }
  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector(".slideshow__autoplay"), this.autoplaySpeed = 1e3 * this.slider.dataset.speed, this.sliderAutoplayButton.addEventListener("click", this.autoPlayToggle.bind(this)), this.addEventListener("mouseover", this.focusInHandling.bind(this)), this.addEventListener("mouseleave", this.focusOutHandling.bind(this)), this.addEventListener("focusin", this.focusInHandling.bind(this)), this.addEventListener("focusout", this.focusOutHandling.bind(this)), this.play(), this.autoplayButtonIsSetToPlay = !0
  }
  onButtonClick(t) {
    super.onButtonClick(t);
    const e = 1 === this.currentPage,
      i = this.currentPage === this.sliderItemsToShow.length;
    (e || i) && (e && "previous" === t.currentTarget.name ? this.slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length : i && "next" === t.currentTarget.name && (this.slideScrollPosition = 0), this.slider.scrollTo({
      left: this.slideScrollPosition
    }))
  }
  update() {
    super.update(), this.sliderControlButtons = this.querySelectorAll(".slider-counter__link"), this.prevButton.removeAttribute("disabled"), this.sliderControlButtons.length && (this.sliderControlButtons.forEach((t => {
      t.classList.remove("slider-counter__link--active"), t.removeAttribute("aria-current")
    })), this.sliderControlButtons[this.currentPage - 1].classList.add("slider-counter__link--active"), this.sliderControlButtons[this.currentPage - 1].setAttribute("aria-current", !0))
  }
  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay), this.autoplayButtonIsSetToPlay ? this.pause() : this.play(), this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay
  }
  focusOutHandling(t) {
    const e = t.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(t.target);
    this.autoplayButtonIsSetToPlay && !e && this.play()
  }
  focusInHandling(t) {
    (t.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(t.target)) && this.autoplayButtonIsSetToPlay ? this.play() : this.autoplayButtonIsSetToPlay && this.pause()
  }
  play() {
    this.slider.setAttribute("aria-live", "off"), clearInterval(this.autoplay), this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed)
  }
  pause() {
    this.slider.setAttribute("aria-live", "polite"), clearInterval(this.autoplay)
  }
  togglePlayButtonState(t) {
    t ? (this.sliderAutoplayButton.classList.add("slideshow__autoplay--paused"), this.sliderAutoplayButton.setAttribute("aria-label", window.accessibilityStrings.playSlideshow)) : (this.sliderAutoplayButton.classList.remove("slideshow__autoplay--paused"), this.sliderAutoplayButton.setAttribute("aria-label", window.accessibilityStrings.pauseSlideshow))
  }
  autoRotateSlides() {
    const t = this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.slider.querySelector(".slideshow__slide").clientWidth;
    this.slider.scrollTo({
      left: t
    })
  }
  setSlideVisibility() {
    this.sliderItemsToShow.forEach(((t, e) => {
      const i = t.querySelectorAll("a");
      e === this.currentPage - 1 ? (i.length && i.forEach((t => {
        t.removeAttribute("tabindex")
      })), t.setAttribute("aria-hidden", "false"), t.removeAttribute("tabindex")) : (i.length && i.forEach((t => {
        t.setAttribute("tabindex", "-1")
      })), t.setAttribute("aria-hidden", "true"), t.setAttribute("tabindex", "-1"))
    }))
  }
  linkToSlide(t) {
    t.preventDefault();
    const e = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * (this.sliderControlLinksArray.indexOf(t.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: e
    })
  }
}
customElements.define("slideshow-component", SlideshowComponent);
class VariantSelects extends HTMLElement {
  constructor() {
    super(), this.addEventListener("change", this.onVariantChange)
  }
  onVariantChange() {
    this.updateOptions(), this.updateMasterId(), this.toggleAddButton(!0, "", !1), this.updatePickupAvailability(), this.removeErrorMessage(), this.updateVariantStatuses(), this.currentVariant ? (this.updateMedia(), this.updateURL(), this.updateVariantInput(), this.renderProductInfo(), this.updateShareUrl()) : (this.toggleAddButton(!0, "", !0), this.setUnavailable())
  }
  updateOptions() {
    this.options = Array.from(this.querySelectorAll("select"), (t => t.value))
  }
  updateMasterId() {
    this.currentVariant = this.getVariantData().find((t => !t.options.map(((t, e) => this.options[e] === t)).includes(!1)))
  }
  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;
    document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`).forEach((t => t.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, !0)));
    const t = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!t) return;
    const e = t.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);
    t.prepend(e)
  }
  updateURL() {
    this.currentVariant && "false" !== this.dataset.updateUrl && window.history.replaceState({}, "", `${this.dataset.url}?variant=${this.currentVariant.id}`)
  }
  updateShareUrl() {
    const t = document.getElementById(`Share-${this.dataset.section}`);
    t && t.updateUrl && t.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`)
  }
  updateVariantInput() {
    document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`).forEach((t => {
      const e = t.querySelector('input[name="id"]');
      e.value = this.currentVariant.id, e.dispatchEvent(new Event("change", {
        bubbles: !0
      }))
    }))
  }
  updateVariantStatuses() {
    const t = this.variantData.filter((t => this.querySelector(":checked").value === t.option1)),
      e = [...this.querySelectorAll(".product-form__input")];
    e.forEach(((i, s) => {
      if (0 === s) return;
      const n = [...i.querySelectorAll('input[type="radio"], option')],
        r = e[s - 1].querySelector(":checked").value,
        o = t.filter((t => t.available && t[`option${s}`] === r)).map((t => t[`option${s + 1}`]));
      this.setInputAvailability(n, o)
    }))
  }
  setInputAvailability(t, e) {
    t.forEach((t => {
      e.includes(t.getAttribute("value")) ? t.innerText = t.getAttribute("value") : t.innerText = window.variantStrings.unavailable_with_option.replace("[value]", t.getAttribute("value"))
    }))
  }
  updatePickupAvailability() {
    const t = document.querySelector("pickup-availability");
    t && (this.currentVariant && this.currentVariant.available ? t.fetchAvailability(this.currentVariant.id) : (t.removeAttribute("available"), t.innerHTML = ""))
  }
  removeErrorMessage() {
    const t = this.closest("section");
    if (!t) return;
    const e = t.querySelector("product-form");
    e && e.handleErrorMessage()
  }
  renderProductInfo() {
    const t = this.currentVariant.id,
      e = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;
    fetch(`${this.dataset.url}?variant=${t}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`).then((t => t.text())).then((i => {
      if (this.currentVariant.id !== t) return;
      const s = (new DOMParser).parseFromString(i, "text/html"),
        n = document.getElementById(`price-${this.dataset.section}`),
        r = s.getElementById(`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`),
        o = s.getElementById(`Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`),
        a = document.getElementById(`Sku-${this.dataset.section}`),
        l = s.getElementById(`Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`),
        d = document.getElementById(`Inventory-${this.dataset.section}`);
      r && n && (n.innerHTML = r.innerHTML), l && d && (d.innerHTML = l.innerHTML), o && a && (a.innerHTML = o.innerHTML, a.classList.toggle("visibility-hidden", o.classList.contains("visibility-hidden")));
      const u = document.getElementById(`price-${this.dataset.section}`);
      u && u.classList.remove("visibility-hidden"), d && d.classList.toggle("visibility-hidden", "" === l.innerText);
      const c = s.getElementById(`ProductSubmitButton-${e}`);
      this.toggleAddButton(!c || c.hasAttribute("disabled"), window.variantStrings.soldOut), publish(PUB_SUB_EVENTS.variantChange, {
        data: {
          sectionId: e,
          html: s,
          variant: this.currentVariant
        }
      })
    }))
  }
  toggleAddButton(t = !0, e, i = !0) {
    const s = document.getElementById(`product-form-${this.dataset.section}`);
    if (!s) return;
    const n = s.querySelector('[name="add"]'),
      r = s.querySelector('[name="add"] > span');
    n && (t ? (n.setAttribute("disabled", "disabled"), e && (r.textContent = e)) : (n.removeAttribute("disabled"), r.textContent = window.variantStrings.addToCart))
  }
  setUnavailable() {
    const t = document.getElementById(`product-form-${this.dataset.section}`),
      e = t.querySelector('[name="add"]'),
      i = t.querySelector('[name="add"] > span'),
      s = document.getElementById(`price-${this.dataset.section}`),
      n = document.getElementById(`Inventory-${this.dataset.section}`),
      r = document.getElementById(`Sku-${this.dataset.section}`);
    e && (i.textContent = window.variantStrings.unavailable, s && s.classList.add("visibility-hidden"), n && n.classList.add("visibility-hidden"), r && r.classList.add("visibility-hidden"))
  }
  getVariantData() {
    return this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent), this.variantData
  }
}
customElements.define("variant-selects", VariantSelects);
class VariantRadios extends VariantSelects {
  constructor() {
    super()
  }
  setInputAvailability(t, e) {
    t.forEach((t => {
      e.includes(t.getAttribute("value")) ? t.classList.remove("disabled") : t.classList.add("disabled")
    }))
  }
  updateOptions() {
    const t = Array.from(this.querySelectorAll("fieldset"));
    this.options = t.map((t => Array.from(t.querySelectorAll("input")).find((t => t.checked)).value))
  }
}
customElements.define("variant-radios", VariantRadios);
// class ProductRecommendations extends HTMLElement {
//   constructor() {
//     super()
//   }
//   connectedCallback() {
//     new IntersectionObserver(((t, e) => {
//       t[0].isIntersecting && (e.unobserve(this), fetch(this.dataset.url).then((t => t.text())).then((t => {
//         const e = document.createElement("div");
//         e.innerHTML = t;
//         const i = e.querySelector("product-recommendations");
//         i && i.innerHTML.trim().length && (this.innerHTML = i.innerHTML), !this.querySelector("slideshow-component") && this.classList.contains("complementary-products") && this.remove(), e.querySelector(".grid__item") && this.classList.add("product-recommendations--loaded")
//       })).catch((t => {
//         console.error(t)
//       })))
//     }).bind(this), {
//       rootMargin: "0px 0px 400px 0px"
//     }).observe(this)
//   }
// }
// customElements.define("product-recommendations", ProductRecommendations);

if (!customElements.get('quick-add-modal')) {
  customElements.define('quick-add-modal', class QuickAddModal extends ModalDialog {
    constructor() {
      super();
      this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
    }

    hide(preventFocus = false) {
      const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      if (cartNotification) cartNotification.setActiveElement(this.openedBy);
      this.modalContent.innerHTML = '';

      if (preventFocus) this.openedBy = null;
      super.hide();
    }

    show(opener) {
      opener.setAttribute('aria-disabled', true);
      opener.classList.add('loading');
      opener.querySelector('.loading-overlay__spinner').classList.remove('hidden');
      fetch(opener.getAttribute('data-product-url'))
        .then((response) => response.text())
        .then((responseText) => {
          const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
          window.responseHTML = responseHTML;
          this.productElement = responseHTML.querySelector('section[id^="MainProduct-"]');
          this.preventDuplicatedIDs();
          this.removeDOMElements();
          this.setInnerHTML(this.modalContent, this.productElement.innerHTML);

          if (window.Shopify && Shopify.PaymentButton) {
            Shopify.PaymentButton.init();
          }

          if (window.ProductModel) window.ProductModel.loadShopifyXR();
          this.preventVariantURLSwitching();
          super.show(opener);
        })
        .finally(() => {
          opener.removeAttribute('aria-disabled');
          opener.classList.remove('loading');
          opener.querySelector('.loading-overlay__spinner').classList.add('hidden');
          theme.quickAdd.init(document.getElementById(`QuickAdd-${opener.dataset.id}`));
          //theme.quickAdd.product.init();
        });
    }

    setInnerHTML(element, html) {
      element.innerHTML = html;

      // Reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
      element.querySelectorAll('script').forEach(oldScriptTag => {
        const newScriptTag = document.createElement('script');
        Array.from(oldScriptTag.attributes).forEach(attribute => {
          newScriptTag.setAttribute(attribute.name, attribute.value)
        });
        newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
        oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
        console.log(newScriptTag);
      });
    }

    preventVariantURLSwitching() {
      const variantPicker = this.modalContent.querySelector('variant-radios,variant-selects');
      if (!variantPicker) return;

      variantPicker.setAttribute('data-update-url', 'false');
    }

    removeDOMElements() {
      const pickupAvailability = this.productElement.querySelector('pickup-availability');
      if (pickupAvailability) pickupAvailability.remove();

      const productModal = this.productElement.querySelector('product-modal');
      if (productModal) productModal.remove();

      const modalDialog = this.productElement.querySelectorAll('modal-dialog');
      if (modalDialog) modalDialog.forEach(modal => modal.remove());
    }

    preventDuplicatedIDs() {
      if ('undefined' !== typeof this.productElement?.dataset?.section) {
        const sectionId = this.productElement?.dataset?.section;
        this.productElement.innerHTML = this.productElement.innerHTML.replaceAll(sectionId, `quickadd-${sectionId}`);
        this.productElement.querySelectorAll('variant-selects, variant-radios, product-info').forEach((element) => {
          element.dataset.originalSection = sectionId;
        });
      }
    }

    removeGalleryListSemantic() {
      const galleryList = this.modalContent.querySelector('[id^="Slider-Gallery"]');
      if (!galleryList) return;

      galleryList.setAttribute('role', 'presentation');
      galleryList.querySelectorAll('[id^="Slide-"]').forEach(li => li.setAttribute('role', 'presentation'));
    }

    updateImageSizes() {
      const product = this.modalContent.querySelector('.product');
      const desktopColumns = product.classList.contains('product--columns');
      if (!desktopColumns) return;

      const mediaImages = product.querySelectorAll('.product__media img');
      if (!mediaImages.length) return;

      let mediaImageSizes = '(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)';

      if (product.classList.contains('product--medium')) {
        mediaImageSizes = mediaImageSizes.replace('715px', '605px');
      } else if (product.classList.contains('product--small')) {
        mediaImageSizes = mediaImageSizes.replace('715px', '495px');
      }

      mediaImages.forEach(img => img.setAttribute('sizes', mediaImageSizes));
    }
  });
}


class Accordion {
  constructor(el) {
    // Store the <details> element
    this.el = el;
    // Store the <summary> element
    this.summary = el.querySelector("summary");
    // Store the <div class="content"> element
    this.content = el.querySelector(".accordion__content");

    // Store the animation object (so we can cancel it if needed)
    this.animation = null;
    // Store if the element is closing
    this.isClosing = false;
    // Store if the element is expanding
    this.isExpanding = false;
    // Detect user clicks on the summary element
    this.summary.addEventListener("click", (e) => this.onClick(e));
  }

  onClick(e) {
    // Stop default behaviour from the browser
    e.preventDefault();
    // Add an overflow on the <details> to avoid content overflowing
    this.el.style.overflow = "hidden";
    // Check if the element is being closed or is already closed
    if (this.isClosing || !this.el.open) {
      this.open();
      // Check if the element is being openned or is already open
    } else if (this.isExpanding || this.el.open) {
      this.shrink();
    }
  }

  shrink() {
    // Set the element as "being closed"
    this.isClosing = true;

    // Store the current height of the element
    const startHeight = `${this.el.offsetHeight}px`;
    // Calculate the height of the summary
    const endHeight = `${this.summary.offsetHeight}px`;

    // If there is already an animation running
    if (this.animation) {
      // Cancel the current animation
      this.animation.cancel();
    }

    // Start a WAAPI animation
    this.animation = this.el.animate(
      {
        // Set the keyframes from the startHeight to endHeight
        height: [startHeight, endHeight],
      },
      {
        duration: 400,
        easing: "ease-out",
      }
    );

    // When the animation is complete, call onAnimationFinish()
    this.animation.onfinish = () => this.onAnimationFinish(false);
    // If the animation is cancelled, isClosing variable is set to false
    this.animation.oncancel = () => (this.isClosing = false);
  }

  open() {
    // Apply a fixed height on the element
    this.el.style.height = `${this.el.offsetHeight}px`;
    // Force the [open] attribute on the details element
    this.el.open = true;
    // Wait for the next frame to call the expand function
    window.requestAnimationFrame(() => this.expand());
  }

  expand() {
    // Set the element as "being expanding"
    this.isExpanding = true;
    // Get the current fixed height of the element
    const startHeight = `${this.el.offsetHeight}px`;
    // Calculate the open height of the element (summary height + content height)
    const endHeight = `${
      this.summary.offsetHeight + this.content.offsetHeight
    }px`;

    // If there is already an animation running
    if (this.animation) {
      // Cancel the current animation
      this.animation.cancel();
    }

    // Start a WAAPI animation
    this.animation = this.el.animate(
      {
        // Set the keyframes from the startHeight to endHeight
        height: [startHeight, endHeight],
      },
      {
        duration: 400,
        easing: "ease-out",
      }
    );
    // When the animation is complete, call onAnimationFinish()
    this.animation.onfinish = () => this.onAnimationFinish(true);
    // If the animation is cancelled, isExpanding variable is set to false
    this.animation.oncancel = () => (this.isExpanding = false);
  }

  onAnimationFinish(open) {
    // Set the open attribute based on the parameter
    this.el.open = open;
    // Clear the stored animation
    this.animation = null;
    // Reset isClosing & isExpanding
    this.isClosing = false;
    this.isExpanding = false;
    // Remove the overflow hidden and the fixed height
    this.el.style.height = this.el.style.overflow = "";
  }
}

document.querySelectorAll(".product__accordion details").forEach((el) => {
  new Accordion(el);
});
